import {Modal} from '@mui/material';
import {Loading} from 'presentation/components/Loading/Loading';
import React from 'react';
import {translations} from 'presentation/translations-new';
import {LoadingLocationProps} from './types';
import {StyledStack} from './styles';

const {searchingLocation} = translations['pt-br'].privateFlow.bookingFlow.location;

const LoadingLocation = ({open}: LoadingLocationProps) => (
	<Modal open={open} sx={{p: 2}}>
		<StyledStack
			borderRadius={1}
			bgcolor="background.paper"
			direction="column"
			justifyContent="center"
			alignItems="center">
			<Loading text={searchingLocation} size={32} textColor="text.primary" />
		</StyledStack>
	</Modal>
);

export {LoadingLocation};
